import React from "react";

function Footer() {
  return (
    <footer id="colophon" className="site-footer">
      <div className="footer_inner_wrapper footer tm-bg tm-bgcolor-darkgrey tm-bgimage-no">
        <div className="site-footer-bg-layer tm-bg-layer" />
        <div className="site-footer-w">
          <div className="footer-rows">
            <div className="footer-rows-inner">
              <div className="tm-footer-cta-wrapper tm-bg tm-bgcolor-custom tm-textcolor-white">
                <div className="container tm-footer-cta-inner">
                  <div className="tm-ctabox-row row">
                    <div className="widget-area col-xs-12 col-sm-6 col-md-6 col-lg-6 cta-widget-area">
                      <div className="tm-element-heading-content-wrapper left-align tm-reverse-heading-yes tm-seperator-none tm-content-with-desc tm-heading-style-vertical ">
                        <div className="tm-content-header">
                          <h4 className="tm-element-subheading tm-skincolor">
                            Animal Wildest Zoo
                          </h4>
                          <h2 className="tm-element-content-heading">
                            Map Of Animal Zoo
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-516b923 tm-btn-color-white tm-btn-style-outline tm-btn-shape-round elementor-widget elementor-widget-button"
                        data-id="516b923"
                        data-element_type="widget"
                        data-widget_type="button.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-button-wrapper">
                            <a
                              href="contactus"
                              className="elementor-button-link elementor-button elementor-size-sm"
                              role="button"
                            >
                              <span className="elementor-button-content-wrapper">
                                <span className="elementor-button-text">
                                  Contact Us!
                                </span>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="widget-area col-xs-12 col-sm-6 col-md-6 col-lg-6 cta-widget-area"
                      style={{
                        marginLeft: "552px",
                        marginTop: "-358px",
                        zIndex: "7",
                      }}
                    >
                      <div className="row">
                        <div className="col-md-7 col-xs-12">
                          <div className="themetechmount-iconbox themetechmount-iconbox-styleeight">
                            <div className="themetechmount-iconbox-inner">
                              <div className="tm-iconbox-wrapper tm-wrap">
                                <div className="themetechmount-iconbox-icon tm-wrap-cell tm-itype-image">
                                  <div className="tm-icon-type-image">
                                    {/* <noscript>
                                      &lt;img
                                      src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-footer.png"
                                      alt="Icon"&gt;
                                    </noscript> */}
                                    <img
                                      className="lazyload"
                                      src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-footer.png"
                                      data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/img-footer.png"
                                      alt="Icon"
                                    />
                                  </div>
                                </div>
                                <div className="themetechmount-iconbox-heading tm-wrap-cell">
                                  <h2 className="tm-custom-heading">
                                    + 12 012456205
                                  </h2>
                                  <p>
                                    We have over 30 years experience Finc
                                    expertise, our goal is to max.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-5 col-xs-12">
                          <div className="tm_prettyphoto1 elementor-element ">
                            <div className="elementor-widget-container">
                              <h3>2.5k+ </h3>
                              <p>Visited Wilddale Zoo</p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="row tm-formm"
                          style={{ margin: 0, padding: "0 28px" }}
                        >
                          <h2
                            className="tm-custom-heading"
                            style={{
                              fontSize: "21px",
                              marginBottom: "10px",
                            }}
                          >
                            Sign Up For Updates
                          </h2>
                          {/* Mailchimp for WordPress v4.8.6 - https://wordpress.org/plugins/mailchimp-for-wp/ */}
                          <form
                            id="mc4wp-form-1"
                            className="mc4wp-form mc4wp-form-5502"
                            method="post"
                            data-id={5502}
                            data-name="Subscribe Form"
                          >
                            <div className="mc4wp-form-fields">
                              <div className="mailchimp-inputbox">
                                <div className="mailchimp-inputbox row tm-wrap">
                                  <div className="tm-wrap-cell tm-padding">
                                    <input
                                      type="email"
                                      name="EMAIL"
                                      placeholder="Email Address"
                                      required
                                    />
                                  </div>
                                  <div className="tm-wrap-cell">
                                    <input
                                      type="submit"
                                      defaultValue="Subscribe!"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <label style={{display: 'none !important'}}>Leave this
                        field empty if you're human: <input type="text" name="_mc4wp_honeypot" defaultValue tabIndex={-1} autoComplete="off" /></label><input type="hidden" name="_mc4wp_timestamp" defaultValue={1678430787} /><input type="hidden" name="_mc4wp_form_id" defaultValue={5502} /><input type="hidden" name="_mc4wp_form_element_id" defaultValue="mc4wp-form-1" />
                      */}
                            <div className="mc4wp-response" />
                          </form>
                          {/* / Mailchimp for WordPress Plugin */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="second-footer"
                className="sidebar-container second-footer tm-bg tm-bgcolor-transparent tm-textcolor-white tm-bgimage-no tm-footerrow-sepnone"
                role="complementary"
              >
                <div className="second-footer-bg-layer tm-bg-layer" />
                <div className="container tm-container-for-footer">
                  <div className="second-footer-inner">
                    <div className="row multi-columns-row">
                      <div className="widget-area col-xs-12 col-sm-4 col-md-4 col-lg-4 second-widget-area">
                        <aside
                          id="block-7"
                          className="widget-even widget-2 widget widget_block"
                        >
                          <div className="first-footerr">
                            <div className="textwidget widget-text">
                              <div className="footer_logo">
                                <noscript>
                                  &lt;img src="uploads/logo-final.png"
                                  alt="footerlogo"&gt;
                                </noscript>
                                <img
                                  className="lazyload"
                                  src="data:image/svg+xml,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20viewBox=%220%200%20210%20140%22%3E%3C/svg%3E"
                                  data-src="/uploads/logo-final.png"
                                  alt="footerlogo"
                                />
                              </div>
                              <p>
                                WildDale is the world largest environment
                                organisations. We actively work towards
                                protecting wildlife, conserving habitat.
                              </p>
                              <hr />
                              <h2
                                style={{
                                  display: "inline-block",
                                  float: "left",
                                  fontSize: "18px",
                                  lineHeight: "40px",
                                  marginRight: "10px",
                                  marginBottom: "0px",
                                }}
                              >
                                Social Share:
                              </h2>
                              <div className="themetechmount-social-links-wrapper">
                                <ul className="social-icons">
                                  <li className="tm-social-facebook">
                                    <a
                                      aria-label="Facebook"
                                      target="_blank"
                                      href="https://www.facebook.com/people/@/themetechMount18"
                                    >
                                      {/* <i className="tm-wilddale-icon-facebook" /> */}
                                      <i className="fa-brands fa-facebook"></i>
                                    </a>
                                  </li>
                                  <li className="tm-social-twitter">
                                    <a
                                      aria-label="Twitter"
                                      target="_blank"
                                      href="https://twitter.com/themetechmount"
                                    >
                                      <i className="fa-brands fa-twitter"></i>{" "}
                                    </a>
                                  </li>
                                  <li className="tm-social-linkedin">
                                    <a
                                      aria-label="LinkedIn"
                                      target="_blank"
                                      href="https://www.linkedin.com/in/themetech-mount-81a161197/"
                                    >
                                      <i className="fa-brands fa-linkedin"></i>{" "}
                                    </a>
                                  </li>
                                  <li className="tm-social-pinterest">
                                    <a
                                      aria-label="Pinterest"
                                      target="_blank"
                                      href="https://in.pinterest.com/themetechmount/_created/"
                                    >
                                      <i className="fa-brands fa-pinterest"></i>{" "}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </aside>
                      </div>
                      {/* .widget-area */}
                      <div className="widget-area col-xs-12 col-sm-2 col-md-2 col-lg-2 second-widget-area">
                        <aside
                          id="nav_menu-3"
                          className="widget-even widget-2 widget widget_nav_menu"
                        >
                          <h3 className="widget-title">Explore</h3>
                          <div className="menu-explore-container">
                            <ul id="menu-explore-1" className="menu">
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5151">
                                <a href="aboutus/">
                                  About Us
                                </a>
                              </li>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5152">
                                <a href="services2/">
                                  Safari Booking
                                </a>
                              </li>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5153">
                                <a href="services/">
                                  Tour Packages
                                </a>
                              </li>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5154">
                                <a href="contactus/">
                                  National Park Map
                                </a>
                              </li>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5155">
                                <a href="contactus/">
                                  Contact Us
                                </a>
                              </li>
                            </ul>
                          </div>
                        </aside>
                      </div>
                      {/* .widget-area */}
                      <div className="widget-area col-xs-12 col-sm-2 col-md-2 col-lg-2 second-widget-area">
                        <aside
                          id="nav_menu-4"
                          className="widget-even widget-2 widget widget_nav_menu"
                        >
                          <h3 className="widget-title">Useful Links</h3>
                          <div className="menu-use-ful-links-container">
                            <ul id="menu-use-ful-links-1" className="menu">
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5157">
                                <a href="service/support-wildlife/">
                                  Crocodile Exhibit
                                </a>
                              </li>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5156">
                                <a href="service/act-for-wildlife/">
                                  Fact And Figures
                                </a>
                              </li>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5158">
                                <a href="service/wifi-with-hi-speed/">
                                  Herbivores Safari
                                </a>
                              </li>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5159">
                                <a href="service/a-guided-services/">
                                  Summer Festival
                                </a>
                              </li>
                              <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5160">
                                <a href="/service/food-beverages/">
                                  Delux Tent Stay
                                </a>
                              </li>
                            </ul>
                          </div>
                        </aside>
                      </div>
                      {/* .widget-area */}
                      <div className="widget-area col-xs-12 col-sm-4 col-md-4 col-lg-4 second-widget-area">
                        <aside
                          id="themetechmount-recent-posts-3"
                          className="widget-even widget-2 widget themetechmount_widget_recent_entries"
                        >
                          <h3 className="widget-title">Recent Posts</h3>
                          <ul className="tm-recent-post-list">
                            <li className="tm-recent-post-list-li">
                              <a href="#">
                                {/* <noscript>
                                  &lt;img width="150" height="150"
                                  src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-150x150.jpg"
                                  className="attachment-thumbnail size-thumbnail
                                  wp-post-image" alt=""
                                  srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-150x150.jpg
                                  150w,
                                  https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_100/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-100x100.jpg
                                  100w" sizes="(max-width: 150px) 100vw, 150px"
                                  data-id="6131" /&gt;
                                </noscript> */}
                                <img
                                  width={150}
                                  height={150}
                                  src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-150x150.jpg"
                                  data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-150x150.jpg"
                                  className="lazyload attachment-thumbnail size-thumbnail wp-post-image"
                                  alt=""
                                  data-srcset="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-150x150.jpg 150w, https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_100/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-10-100x100.jpg 100w"
                                  data-sizes="(max-width: 150px) 100vw, 150px"
                                  data-id={6131}
                                />
                              </a>
                              <div className="post-detail">
                                <a href="#">
                                  10 Amazing Wildlife Travel Adventures To Try!
                                </a>
                                <span className="post-date">
                                  <i className="fa-light fa-calendar"></i>{" "}
                                  August 10, 2021
                                </span>
                              </div>
                            </li>
                            <li className="tm-recent-post-list-li">
                              <a href="#">
                                <noscript>
                                  &lt;img width="150" height="150"
                                  src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-11-150x150.jpg"
                                  className="attachment-thumbnail size-thumbnail
                                  wp-post-image" alt="" data-id="6132" /&gt;
                                </noscript>
                                <img
                                  width={150}
                                  height={150}
                                  src="https://sp-ao.shortpixel.ai/client/q_lqip,ret_wait,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-11-150x150.jpg"
                                  data-src="https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_150,h_150/https://www.themetechmount.com/wordpress/wilddale/wp-content/uploads/2021/09/post-11-150x150.jpg"
                                  className="lazyload attachment-thumbnail size-thumbnail wp-post-image"
                                  alt=""
                                  data-id={6132}
                                />
                              </a>
                              <div className="post-detail">
                                <a href="#">
                                  Everything Need To Know About Tigers Census
                                </a>
                                <span className="post-date">
                                  <i className="fa-light fa-calendar"></i>
                                  July 16, 2021
                                </span>
                              </div>
                            </li>
                          </ul>
                        </aside>
                      </div>
                      {/* .widget-area */}
                    </div>
                    {/* .row.multi-columns-row */}
                  </div>
                  {/* .second-footer-inner */}
                </div>
                {/*  */}
              </div>
              {/* #secondary */}
              <div className="tm-cta-buttonarea">
                <a href="#" target="_blank" className="tm-button-box">
                  View Maps!
                </a>
              </div>
            </div>
            {/* .footer-inner */}
          </div>
          {/* .footer */}
          <div
            id="bottom-footer-text"
            className="bottom-footer-text tm-bottom-footer-text site-info  tm-bg tm-bgcolor-transparent tm-textcolor-white tm-bgimage-no tm-bordercolor-white"
          >
            <div className="bottom-footer-bg-layer tm-bg-layer" />
            <div className="container tm-container-for-footer">
              <div className="bottom-footer-inner">
                <div className="row multi-columns-row">
                  <div className="col-xs-12 col-sm-7 tm-footer2-left ">
                    Copyright © 2023 <a href="#">WildDale</a>
                    Theme. All rights reserved.{" "}
                  </div>
                  {/*.footer menu */}
                  <div className="col-xs-12 col-sm-5 tm-footer2-right ">
                    <ul className="footer-nav-menu">
                      <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5148">
                        <a href="#">About Us</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5149">
                        <a href="#">Gallery</a>
                      </li>
                      <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-5150">
                        <a href="#">Contact Us</a>
                      </li>
                    </ul>
                  </div>
                  {/*.copyright */}
                </div>
                {/* .row.multi-columns-row */}
              </div>
              {/* .bottom-footer-inner */}
            </div>
            {/*  */}
          </div>
          {/* .footer-text */}
        </div>
        {/* .footer-inner-wrapper */}
      </div>
      {/* .site-footer-inner */}
    </footer>
  );
}

export default Footer;
